export const dollars = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export interface TuitionTotals {
  monthly: number;
  oneTime: number;
}

/**
 * Adds up tuition, keeping monthly tuition apart from one-time fees so the
 * two are never summed into a single misleading number.
 */
export const sumTuition = (
  items: { fee?: number | string | null; monthly?: boolean | number | null }[]
): TuitionTotals =>
  items.reduce<TuitionTotals>(
    (totals, item) => {
      const fee = Number(item.fee) || 0;
      if (item.monthly) totals.monthly += fee;
      else totals.oneTime += fee;
      return totals;
    },
    { monthly: 0, oneTime: 0 }
  );

/** "$230.00 / month + $150.00", or just the part that applies. */
export const formatTuitionTotals = ({ monthly, oneTime }: TuitionTotals) => {
  const parts: string[] = [];
  if (monthly) parts.push(`${dollars.format(monthly)} / month`);
  if (oneTime || !monthly) parts.push(dollars.format(oneTime));
  return parts.join(' + ');
};
